<template>
  <div class="isPro2">
    <div class="centerBox">
      <div class="title">
        <p>{{ title }}</p>
        <p>
          {{ desc }}
        </p>
        <p></p>
      </div>
      <!-- pc -->
      <ul class="pc">
        <li class="isPart_1">
          <div class="mark">
            <div class="partTitle">{{ solution.title }}</div>
            <div class="partDesc">{{ solution.desc }}</div>
            <ul>
              <li v-for="item in solution.list" :key="item.key">
                <img :src="require('@/assets/Solution/isTips.png')" />
                {{ item.text }}
              </li>
            </ul>
          </div>
        </li>
        <li class="isPart_1">
          <div class="mark">
            <div class="partTitle">{{ client.title }}</div>
            <div class="partDesc">{{ client.desc }}</div>
          </div>
        </li>
      </ul>

      <!-- mobile -->
      <div class="mobile">
        <div class="isswiper_pro2_1">
          <div class="swiper-wrapper">
            <div class="swiper-slide swip_1">
              <div class="mark">
                <div class="partTitle">{{ solution.title }}</div>
                <div class="partDesc">{{ solution.desc }}</div>
                <ul>
                  <li v-for="item in solution.list" :key="item.key">
                    <img :src="require('@/assets/Solution/isTips.png')" />
                    {{ item.text }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="swiper-slide swip_2">
              <div class="mark">
                <div class="partTitle">{{ client.title }}</div>
                <div class="partDesc">{{ client.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "我们的解决方案",
      desc: "深度融合体检与慢病管理业务  实现医防融合全闭环",
      solution: {
        title: "解决方案",
        desc: "华信互联与医院共建健康管理中心，实现“以患者为中心”的全病程追踪和管理。",
        list: [
          {
            key: 1,
            text: "智慧检后管理与体检系统",
          },
          {
            key: 2,
            text: "智慧型的随访",
          },
          {
            key: 3,
            text: "慢病管理方案",
          },
          {
            key: 4,
            text: "远程健康监测",
          },
        ],
      },
      client: {
        title: "客户价值",
        desc: "协助医疗机构快速构建体检服务与慢病管理体系，加强患者与医疗机构的业务黏度，构筑闭环平台式医疗场景，提升医疗服务水平和患者满意度，建立起患者与医院之间持续治疗、康复和疾病管理的纽带。",
      },
    };
  },

  mounted() {
    var mySwiper = new Swiper(".isswiper_pro2_1", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
    });
  },
};
</script>

<style scoped>
.isPro2 {
  width: 100%;
}
.centerBox {
  width: 100%;
  margin: 0 auto;
}

.title {
  height: 3rem;
  background: #373948;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}

.title p:nth-child(1) {
  font-weight: 900;
  font-size: 0.3rem;
  line-height: 0.42rem;
}
.title p:nth-child(2) {
  font-size: 0.38rem;
  padding: 0.16rem 0 0.25rem 0;
}

.title p:nth-child(3) {
  width: 0.74rem;
  height: 0.03rem;
  background: #1aa858;
}

.mobile {
  display: none;
}

.pc {
  font-size: 0;
}

.pc .isPart_1 {
  width: 50%;
  display: inline-block;
  min-height: 5.8rem;
  color: #fff;
  box-sizing: border-box;
  vertical-align: top;
  padding-left: 7%;
  position: relative;
}
.mark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  padding-left: 7%;
  box-sizing: border-box;
}
.pc .isPart_1:nth-child(1) {
  background: url("../../assets/xuwei/在未来的医学概念的男医生.jpg") no-repeat;
  background-size: cover;
}

.pc .isPart_1:nth-child(2) {
  background: url("../../assets/xuwei/医疗图标，手的急救.jpg") no-repeat;
  background-size: cover;
}

.pc .isPart_1 .partTitle {
  font-style: normal;
  font-weight: 900;
  font-size: 0.38rem;
  line-height: 0.53rem;
  margin-top: 12.5%;
}
.pc .isPart_1 .partDesc {
  font-style: normal;
  font-weight: normal;
  font-size: 0.22rem;
  line-height: 0.36rem;
  width: 70%;
  margin-top: 0.24rem;
}

.pc .isPart_1 ul {
  margin-top: 0.48rem;
}

.pc .isPart_1 ul li {
  font-style: normal;
  font-weight: normal;
  font-size: 0.24rem;
  line-height: 0.36rem;
  list-style: none;
}

@media screen and (max-width: 1024px) {
  .title {
    height: auto;
    padding: 0.6rem 0;
  }
  .title p:nth-child(1) {
    line-height: 0.67rem;
    font-size: 0.48rem;
  }
  .title p:nth-child(2) {
    max-width: 90%;
    line-height: 0.67rem;
    font-size: 0.38rem;
    text-align: center;
  }

  .mobile {
    display: block;
    overflow: hidden;
  }

  .pc {
    display: none;
  }

  .mobile .swiper-slide {
    height: 5.6rem;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: normal;
    color: #ffffff;
    position: relative;
    /* width: 100%; */
  }

  .title p:nth-child(3) {
    width: 1.3rem;
    height: 0.03rem;
    background: #1aa858;
  }

  .swip_1 {
    background: url("../../assets/xuwei/在未来的医学概念的男医生.jpg") no-repeat;
    background-size: cover;
  }

  .swip_1 .partTitle {
    font-weight: 900;
    font-size: 0.38rem;
    line-height: 0.53rem;
    /* padding-top: 10%; */
    color: #ffffff;
    padding: 10% 8% 0;
  }

  .swip_1 .partDesc {
    font-weight: 400;
    font-size: 0.3rem;
    line-height: 0.54rem;
    margin-top: 0.24rem;
    padding: 0 8%;
  }

  .swip_1 ul {
    list-style: none;
    margin-top: 0.2rem;
    padding: 0 8%;
  }

  .swip_1 ul li {
    font-weight: 400;
    font-size: 0.18rem;
    line-height: 240%;
    display: flex;
    align-items: center;
  }
  .swip_1 ul li img {
    margin-right: 4px;
    width: 0.1rem;
    vertical-align: middle;
  }

  .swip_2 {
    background: url("../../assets/xuwei/医疗图标，手的急救.jpg") no-repeat;
    background-size: cover;
  }

  .swip_2 .partTitle {
    font-weight: 900;
    font-size: 0.38rem;
    line-height: 0.53rem;
    /* padding-top: 10%; */
    color: #ffffff;
    padding: 10% 8% 0;
  }

  .swip_2 .partDesc {
    font-weight: 400;
    font-size: 0.3rem;
    line-height: 0.54rem;
    margin-top: 0.24rem;
    padding: 0 8%;
  }
}
</style>